
import $ from 'jquery';
import { Component, Vue } from 'vue-property-decorator';
import { PqtMeasurement } from '../../backend/backendapi';
import PqtMeasurementRowSeparateTesterEditor from './PqtMeasurementRowSeparateTesterEditor';

@Component({
  components: {
    PqtMeasurementRowSeparateTesterEditor,
  },
})
export default class PqtMeasurementRowSeparateTesterEditModal extends Vue {
  measurement: PqtMeasurement | null = null;

  public open(measurement: PqtMeasurement): void {
    this.measurement = measurement;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
    this.measurement = null;
  }
}
